import { EventLoopMonitorOptions } from "perf_hooks";
import { Limpidite } from "../SANDRE/limpidite";
import { EMeteo } from "../SANDRE/meteo";
import { VisibiliteFond } from "../SANDRE/visibilite-fond";
import { EBloomAlgal } from "./enum/bloom-algal";
import { EIntensiteVent } from "./enum/intensite-vent";
import { EPresenceMarnage } from "./enum/presence-marnage";
import { ESigneEmergence } from "./enum/signe-emergence";
import { ESurfaceEau } from "./enum/surface-eau";

export class ConditionPrelevementLac {
    IntensiteVent: EIntensiteVent;
    SurfaceEau: ESurfaceEau;
    Meteo: EMeteo;
    BloomAlgal: EBloomAlgal;
    PresenceMarnage: EPresenceMarnage;
    AmplitudeMarnage: number;
    HauteurVague: number;
    Profondeur: number;
    CoteNGF: number;
    CoteLimnimetrique: number;
    // IML
    Limpidite: Limpidite;
    Visibilite: VisibiliteFond;
    SigneEmergence: ESigneEmergence;
    // !IML

    static mapFromJSON(json: any): ConditionPrelevementLac {
        const c = new ConditionPrelevementLac();

        c.IntensiteVent = json.intensiteVent;
        c.SurfaceEau = json.surfaceEau;
        c.Meteo = json.meteo;
        c.BloomAlgal = json.bloomAlgal;
        c.PresenceMarnage = json.presenceMarnage;
        c.AmplitudeMarnage = json.amplitudeMarnage;
        c.HauteurVague = json.hauteurVague;
        c.Profondeur = json.profondeur;
        c.CoteNGF = json.coteNGF;
        c.CoteLimnimetrique = json.coteLimnimetrique;
        c.Limpidite = json.limpidite;
        c.Visibilite = json.visibilite;
        c.SigneEmergence = json.signeEmergence;

        return c;
    }
}